if (!customElements.get('atelier-review-photos')) {
 customElements.define('atelier-review-photos', class extends HTMLElement {
  connectedCallback() {
   if (this.controller || this.dataset.layout === 'grid') return;
   const track = this.querySelector('.acr-gallery');
   if (!track) return;
   this.controller = new AbortController();
   const options = {signal:this.controller.signal};
   const buttons = [...this.querySelectorAll('[data-direction]')];
   const motion = matchMedia('(prefers-reduced-motion: reduce)');
   const update = () => {if(buttons[0]) buttons[0].disabled=track.scrollLeft<=1;if(buttons[1]) buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-1;};
   const move = (direction,loop=false) => {
    const end=track.scrollLeft+track.clientWidth>=track.scrollWidth-1;
    if(loop&&end) track.scrollTo({left:0,behavior:motion.matches?'auto':'smooth'});
    else track.scrollBy({left:direction*track.clientWidth,behavior:motion.matches?'auto':'smooth'});
   };
   buttons.forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.direction)),options));
   track.addEventListener('scroll',update,{...options,passive:true});
   this.observer=new ResizeObserver(update);this.observer.observe(track);update();
   if(this.dataset.autoplay==='true') {
    this.toggle=document.createElement('button');this.toggle.className='acr-autoplay-toggle';this.toggle.type='button';this.append(this.toggle);
    this.paused=motion.matches;let hovering=false,visible=false;
    const schedule=()=>{
     clearInterval(this.timer);this.toggle.textContent=this.paused?(this.dataset.playLabel || 'Play'):(this.dataset.pauseLabel || 'Pause');this.toggle.setAttribute('aria-pressed',String(!this.paused));
     if(!this.paused&&!hovering&&visible&&!document.hidden&&!motion.matches) this.timer=setInterval(()=>move(1,true),Math.max(3,Number(this.dataset.interval)||5)*1000);
    };
    this.toggle.addEventListener('click',()=>{this.paused=!this.paused;schedule();},options);
    this.addEventListener('mouseenter',()=>{hovering=true;schedule();},options);
    this.addEventListener('mouseleave',()=>{hovering=false;schedule();},options);
    this.addEventListener('focusin',()=>{hovering=true;schedule();},options);
    this.addEventListener('focusout',()=>{hovering=false;schedule();},options);
    track.addEventListener('pointerdown',()=>{this.paused=true;schedule();},options);
    document.addEventListener('visibilitychange',schedule,options);motion.addEventListener('change',schedule,options);
    this.visibility=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();});this.visibility.observe(this);schedule();
   }
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();this.visibility?.disconnect();clearInterval(this.timer);this.toggle?.remove();}
 });
}

if (!customElements.get('atelier-review-count')) {
 customElements.define('atelier-review-count', class extends HTMLElement {
  connectedCallback() {
   if (this.observer) return;
   const update = () => {
    const source = document.querySelector('.product__info-container .atelier-review-text');
    const count = source?.textContent.match(/\d[\d.,\s]*\+?/);
    if (!count) return;
    const template = this.dataset.template || '[count]';
    const parts = template.split('[count]');
    const text = parts.join(count[0].trim());
    if (this.textContent !== text || !this.querySelector('strong')) {
     const number = document.createElement('strong'); number.textContent = count[0].trim();
     const nodes = [];
     parts.forEach((part,index) => { if(index) nodes.push(number.cloneNode(true)); nodes.push(document.createTextNode(part)); });
     this.replaceChildren(...nodes);
    }
   };
   this.controller = new AbortController();
   const connect = () => {
    this.observer?.disconnect();
    const source = document.querySelector('.product__info-container .atelier-review-text');
    update();
    if (source) this.observer.observe(source,{subtree:true,childList:true,characterData:true});
   };
   this.observer = new MutationObserver(update);
   document.addEventListener('shopify:section:load',connect,{signal:this.controller.signal});
   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',connect,{once:true,signal:this.controller.signal});
   connect();
  }
  disconnectedCallback() {this.controller?.abort();this.controller=null;this.observer?.disconnect();this.observer=null;}
 });
}
